import axios from "./general/HttpClient";

export const GenerateCardImage = (cardID, setMessage) => {
    let now = new Date();
    const _messages = [] as string[];
    setMessage("Starting generation...");
    return new Promise((resolve, reject) => {
        var eventSource = new EventSource("/api/cards/generateImage?id=" + cardID, { withCredentials: true });

        eventSource.onmessage = (event) => {
            console.log(event.data);

            if (event.data.indexOf("cards") == 0) {
                setMessage("Generating Image");
            }

            if (event.data.indexOf("done") == 0) {
                setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");
                eventSource.close();
                resolve(true);
            }
        };
    });
};
